import React from 'react';
import { useTranslation } from 'react-i18next';
import BasePageView from '../sharedComponents/BasePageView/BasePageView';

export default function NetworkingView() {
  const { t } = useTranslation();

  return (
    <BasePageView
      title={t('event.networking-opportunities')}
      informaPageId="networking"
    />
  );
}
